import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'thread',
    header: 'Plan Type / Threat',
    type: 'text',
  },
  {
    key: 'planOwnerfirstName',
    header: 'Owner First Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 35,
  },
  {
    key: 'planOwnerlastName',
    header: 'Owner Last Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 35,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    placeholder: 'Not Provided',
    width: 40,
  },
  {
    key: 'phone',
    header: 'Phone',
    type: 'text',
    placeholder: 'Not Provided',
  },
];
